<template>
  <div
    class="form-group"
    :class="{
      'has-error': errors.has(validationName),
      'form-group-active': active
    }"
  >
    <label class="control-label" v-if="label">{{ label }}</label>
    <model-select
      :options="options"
      :value="value"
      :isDisabled="disabled"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      @blur="changeFocus()"
      @focus="changeFocus()"
    ></model-select>
    <error-message :message="errors.first(name)"></error-message>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";

export default {
  inject: ["$validator"],
  name: "form-group-search-select",
  components: {
    ModelSelect
  },
  props: {
    label: String,
    id: String,
    name: String,
    scope: String,
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    required: String,
    value: null,
    options: Array
  },
  data() {
    return {
      active: false
    };
  },
  computed: {
    validationName() {
      return this.scope ? `${this.scope}.${this.name}` : this.name;
    }
  },
  mounted() {
    this.$el.value = this.value;
  },
  methods: {
    changeFocus() {
      this.active = !this.active;
    }
  },
  watch: {
    options(value) {
      for (let key in this.$children) {
        if (this.$children[key].searchText != undefined) {
          this.$children[key].searchText = "";
        }
      }
      this.$emit("input", null);
    }
  }
};
</script>

<style>
.ui.selection.dropdown {
  border: 1px solid #ccc !important;
  min-height: 40px !important;
  padding-top: 12px !important;
}

.form-group.has-error .ui.selection.dropdown {
  border-color: #a94442 !important;
}

.ui.dropdown .menu > .item,
.ui.selection.dropdown .menu > .item {
  padding: 6px 15px !important;
  font-size: 14px !important;
}

.ui.dropdown .menu > .item:hover {
  background-color: #ddd !important;
}

.ui.selection.active.dropdown .menu {
  border: 1px solid #ccc !important;
}

.ui.dropdown:not(.button) > .default.text,
.ui.default.dropdown:not(.button) > .text {
  color: rgba(130, 130, 130, 0.9) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/FormGroupSearchSelect.vue